import { CatalogCategory } from "../types/catalogCategory";

export const resolveCategoryLabel = (
  category: CatalogCategory | null | undefined,
  generalLabel: string
): string => category?.name ?? generalLabel;
